// App-key registration (contracts.md registry row "App-key registration"; instrumentation-and-ingest
// §6; extends the Ingest contract).
//
// The per-app public WRITE key the SDK sends on ingest. It NEVER grants read. The raw key is shown
// EXACTLY ONCE at mint; only its SHA-256 digest is stored (apps/api hashWriteKey,
// write-key-resolver.ts:27), so the raw value never sits at rest.
import { z } from "zod";
import { AppKeyId } from "../ids.js";
/**
 * The ISSUED public write-key format: `wk_` followed by exactly 64 lowercase hex chars. This pins the
 * format the platform MINTS. (Distinct from @nightcrew/ingest's wire validator, which stays
 * intentionally permissive for an opaque bearer key at the hostile ingest boundary.)
 */
export const PublicWriteKey = z.string().regex(/^wk_[0-9a-f]{64}$/);
/** The mint response. `rawKey` is returned ONCE and never again; only its digest is stored. */
export const RegisterAppKeyResponse = z.object({
    appKeyId: AppKeyId,
    rawKey: PublicWriteKey,
});
//# sourceMappingURL=app-key.js.map